<template>
  <div class="module-afiliasi">
    <SOSlotBase :container-name="'mutasi-page-content'" :loading="isFetching && !isLoadMore">
      <template v-slot:title-bar>
        <div>
          <SOTitleBar :page-title="'Mutasi Saldo'" :type="'back'" @back="back" />
        </div>
      </template>
      <template v-slot:loading-page>
        <div>
          <SOLoadingPage/>
        </div>
      </template>
      <template v-slot:empty-state>
        <SOEmptyState
          v-if="!isFetching && mutasiSaldo.length < 1"
          :message="'Belum ada mutasi'"
          :subMessage="'Saldo afiliasi belum pernah berubah'"
        />
      </template>
      <template v-slot:content>
        <div class="p-x-20">
          <SOCardMutasiSaldo :data-list="mutasiSaldo" v-if="!isFetching || isLoadMore"/>
          <SOLoadMoreLoading :id="'load-more-mutasi-saldo'" :loading="isLoadMore" />
        </div>
      </template>
    </SOSlotBase>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOEmptyState from "@/so-components/global/ui/SOEmptyState";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading";

import SOCardMutasiSaldo from "../components/SOCardMutasiSaldo.vue";

import { moduleName } from "../store/state";

export default {
  name: "MutasiSaldoPage",
  components: {
    SOSlotBase,
    SOTitleBar,
    SOCardMutasiSaldo,
    SOLoadMoreLoading,
    SOLoadingPage,
    SOEmptyState,
  },
  mounted() {
    this.init();
    this.scroll();
  },
  computed: {
    ...mapGetters(moduleName, {
      response: "getResponse",
      isFetching: "isFecthing",
      mutasiSaldo: "mutasiSaldo",
      isLoadMore: "isLoadMore",
      pagination: "pagination",
    }),
  },
  methods: {
    ...mapActions({
      getMutasiSaldo: `${moduleName}/getMutasiSaldo`,
      resetPagination: `${moduleName}/resetPagination`,
      resetMutasiSaldo: `${moduleName}/resetMutasiSaldo`,
    }),
    back() {
      this.$router.push({ name: "afiliasi.dashboard" });
      this.resetMutasiSaldo();
    },
    async init() {
      await this.resetPagination();
      await this.getMutasiSaldo();
    },
    loadData() {
      this.getMutasiSaldo();
    },
    async scroll() {
      window.onscroll = async () => {
        if (!this.response.success) {
          return;
        }

        let payload = {
          idLoadMore: "load-more-mutasi-saldo",
          container: "mutasi-page-content",
          pagination: this.pagination,
          callback: this.loadData,
        };

        await this.$store.dispatch("helper/scroll", payload);
      };
    },
  },
};
</script>
